import React from "react";
import { Redirect, Route } from "react-router-dom";

function ProtectedRoute({ appProps, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        appProps.isAuthenticated ? (
          <Component {...props} {...appProps} />
        ) : (
          // <Redirect to="/login" />
          console.log("not logged in")
        )
      }
    />
  );
}

export default ProtectedRoute;
